package com.hyperether.goodjob.scenes.jobs.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import com.hyperether.goodjob.models.Job
import com.hyperether.goodjob.models.Site
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.clock_small
import com.hyperether.goodjob.resources.employees_job_item
import com.hyperether.goodjob.resources.map_job_item
import com.hyperether.goodjob.resources.no_information
import com.hyperether.goodjob.resources.not_assigned
import com.hyperether.goodjob.resources.user_check_job_item
import com.hyperether.goodjob.scenes.components.CircleWithInitial
import com.hyperether.goodjob.scenes.components.RoundedCornerCheckbox
import com.hyperether.goodjob.scenes.components.clickableWithPointer
import com.hyperether.goodjob.theme.AddEmployeeInputColor
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.util.DateTimeUtil
import com.hyperether.goodjob.util.StatusColor
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.stringResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun JobsItem(
    site: Site?,
    job: Job,
    isInEditMode: Boolean,
    selectedJobs: MutableList<Job>,
    onJobSelected: (Job, Boolean) -> Unit,
    onItemClick: () -> Unit,
    isMapScreen: Boolean = false
) {

    Column(
        modifier = Modifier.fillMaxWidth()
    ) {
        if (!isMapScreen) {
            job.startDate?.let {
                Text(
                    text = DateTimeUtil.jobListDateFormatter(it),
                    color = Color.Gray,
                    fontSize = 14.toScaleSp(),
                    fontWeight = FontWeight.Bold,
                    modifier = Modifier.padding(
                        bottom = 8.toScaleDp(),
                        start = 8.toScaleDp(),
                        top = 10.toScaleDp()
                    )
                )
            }
        }
        Row {
            if (isInEditMode) {
                RoundedCornerCheckbox(
                    isChecked = selectedJobs.contains(job),
                    onCheckedChange = { checked ->
                        onJobSelected(job, checked)
                    }
                )
            }
            Spacer(modifier = Modifier.width(10.toScaleDp()))

            val modifier = if (!isMapScreen) Modifier
                .fillMaxWidth()
                .clip(RoundedCornerShape(8.toScaleDp()))
                .border(1.toScaleDp(), Color.LightGray, RoundedCornerShape(8.toScaleDp()))
                .clickableWithPointer { onItemClick() }
            else Modifier
                .fillMaxWidth()
                .clip(RoundedCornerShape(8.toScaleDp()))
                .border(1.toScaleDp(), AddEmployeeInputColor, RoundedCornerShape(8.toScaleDp()))
                .clickableWithPointer { onItemClick() }
                .padding(10.toScaleDp())

            Box(
                modifier =  modifier
            ) {
                Column(
                    modifier = Modifier
                        .padding(10.toScaleDp())
                ) {
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.SpaceBetween,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        job.jobTitle?.let {
                            Text(
                                text = it,
                                color = Color.Black,
                                fontWeight = FontWeight.Bold,
                                fontSize = 18.toScaleSp(),
                                modifier = Modifier
                                    .weight(1f)
                                    .padding(bottom = 8.toScaleDp()),
                                maxLines = 2,
                                overflow = TextOverflow.Ellipsis
                            )
                        }
                        Box(
                            modifier = Modifier
                                .size(16.toScaleDp())
                                .background(
                                    color = StatusColor.getStatusColor(job.status),
                                    shape = CircleShape
                                )
                        )
                    }

                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                        modifier = Modifier.padding(bottom = 4.toScaleDp())
                    ) {
                        Image(
                            modifier = Modifier.size(16.toScaleDp()),
                            painter = painterResource(Res.drawable.user_check_job_item),
                            contentDescription = null,
                        )
                        Spacer(modifier = Modifier.width(8.toScaleDp()))
                        site?.let {
                            Text(
                                fontSize = 14.toScaleSp(),
                                text = it.siteName ?: it.personName
                                ?: stringResource(Res.string.no_information),
                                color = BlueApp,
                            )
                        } ?: run {
                            Text(
                                fontSize = 14.toScaleSp(),
                                text = stringResource(Res.string.no_information),
                                color = Color.DarkGray,
                                fontWeight = FontWeight.W400
                            )
                        }
                    }
                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                        modifier = Modifier.padding(bottom = 4.toScaleDp())
                    ) {
                        Image(
                            modifier = Modifier.size(16.toScaleDp()),
                            painter = painterResource(Res.drawable.map_job_item),
                            contentDescription = null,
                        )
                        Spacer(modifier = Modifier.width(8.toScaleDp()))
                        if (site?.addressObject?.address?.isNotEmpty() == true) {
                            Text(
                                fontSize = 14.toScaleSp(),
                                text = site.addressObject?.address
                                    ?: stringResource(Res.string.no_information),
                                color = BlueApp,
                            )
                        } else {
                            Text(
                                fontSize = 14.toScaleSp(),
                                text = stringResource(Res.string.no_information),
                                color = Color.DarkGray,
                                fontWeight = FontWeight.W400
                            )
                        }
                    }
                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                        modifier = Modifier.padding(bottom = 4.toScaleDp())
                    ) {
                        Image(
                            modifier = Modifier.size(16.toScaleDp()),
                            painter = painterResource(Res.drawable.clock_small),
                            contentDescription = null,
                        )
                        Spacer(modifier = Modifier.width(8.toScaleDp()))
                        job.start_at?.let { start ->
                            job.end_at?.let { end ->
                                if (start.isNotEmpty() && end.isNotEmpty()) {
                                    Text(
                                        fontSize = 14.toScaleSp(),
                                        text = "$start - $end",
                                        color = Color.Black,
                                        fontWeight = FontWeight.Bold
                                    )
                                } else {
                                    Text(
                                        fontSize = 14.toScaleSp(),
                                        text = stringResource(Res.string.no_information),
                                        color = Color.Black,
                                        fontWeight = FontWeight.Bold
                                    )
                                }
                            }
                        } ?: Text(
                            fontSize = 14.toScaleSp(),
                            text = stringResource(Res.string.no_information),
                            color = Color.DarkGray,
                            fontWeight = FontWeight.W400
                        )
                    }
                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                        modifier = Modifier.padding(bottom = 4.toScaleDp())
                    ) {
                        val employees = job.assignees?.employees
                        val teams = job.assignees?.teams
                        if (employees?.isNotEmpty() == true || teams?.isNotEmpty() == true) {
                            val names: List<String> =
                                (employees?.map { it?.getName() } ?: emptyList())
                                    .filterNotNull()
                                    .plus((teams?.map { it?.name } ?: emptyList()).filterNotNull())
                            Row(
                                modifier = Modifier
                                    .fillMaxWidth(),
                                horizontalArrangement = Arrangement.Start
                            ) {
                                names.forEach { name ->
                                    CircleWithInitial(
                                        name = name,
                                        size = 20.toScaleDp(),
                                        fontSize = 12
                                    )
                                }
                            }
                        } else {
                            Image(
                                modifier = Modifier.size(16.toScaleDp()),
                                painter = painterResource(Res.drawable.employees_job_item),
                                contentDescription = null,
                            )
                            Spacer(modifier = Modifier.width(8.toScaleDp()))
                            Text(
                                fontSize = 14.toScaleSp(),
                                text = stringResource(Res.string.not_assigned),
                                color = Color.DarkGray,
                                fontWeight = FontWeight.W400
                            )
                        }
                    }
                }
            }
        }
    }
}